import React from 'react';
import { Node } from '@uncinc/react-drupal-core';
import i18next from '../../../config/i18next';

import {
  Container,
  Button,
  Loader,
} from '../../../components';

const ProjectsAll = ({ pager, onLoadMore, loading, ...props }) => {
  const { entities } = props;
  const itemsPerPage = pager.get('items_per_page');
  const totalItems = pager.get('total_items');
  const currentPage = pager.get('current_page');
  const currentItemCount = (currentPage + 1) * itemsPerPage;
  const pagerVisible = currentItemCount < totalItems;

  return (
    <div className="View ProjectsAll">
      <Container>
        <div className="row">
          {entities.count() === 0 && (
            <div className="View__empty col-12 mb-6">{ i18next.t('views.no_results') }</div>
          )}
          {entities.map((entity) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const className = 'col-12 col-lg-4';
            return (
              <div key={`${uuid}:${langcode}`} className={className}>
                <Node
                  id={id}
                  key={`${uuid}:${langcode}`}
                  isActivePath
                  entity={entity}
                  viewMode="teaser"
                />
              </div>
            );
          })}
        </div>
      </Container>
      {pagerVisible && (
        <div className="ViewAwards__button">
          <Button
            className="ViewAwards__Button"
            secondary
            withIcon
            buttonIconVertical
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onLoadMore();
            }}>{ i18next.t('view_load_more') }
          </Button>
        </div>
      )}
      <Loader loading={loading} />
    </div>
  );
};

export default ProjectsAll;
